var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"black--text mx-1",on:{"click":_vm.exportPDF}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("mdi-printer")]),_vm._v(" Print ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }